import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'jobsDefinition',
        url: '/jobs-definition',
        component: 'wtJobsDefinitionState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer])
        },
        data: {
            visible: true,
            sortingOrder: 10,
            icon: 'fa-clock-o',
            displayName: 'Tasks',
            editRoles: [Roles.administrator, Roles.master, Roles.engineer],
            editButtonVisibility: () => false,
            subStates: ['jobsDefinition', 'timelineDetails', 'emails', 'triggerAction', 'taskProgress', 'workflowsOverview', 'performanceHeatMap', 'onlineMessages']
        }
    }
];

export default states;